(function () {
  'use strict';

  /* ---------- Horizontal-order masonry (1 2 3 4 5 / 6 7 8 9 10) ---------- */
  function colsFor(w, smallTwo) {
    if (w <= 380) return smallTwo ? 2 : 1;
    if (w <= 760) return 2;
    if (w <= 900) return 3;
    if (w <= 1100) return 4;
    return 5;
  }

  document.querySelectorAll('[data-reviews-grid]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.review-card'));
    if (!cards.length) return;

    /* lock the reading order once, by the server-rendered index */
    cards.sort(function (a, b) {
      return (parseInt(a.getAttribute('data-review-index'), 10) || 0) -
             (parseInt(b.getAttribute('data-review-index'), 10) || 0);
    });

    grid.classList.add('is-masonry-js');
    var currentCols = 0;

    function layout() {
      var cols = colsFor(window.innerWidth || document.documentElement.clientWidth, grid.getAttribute('data-small-two') === 'true');
      if (cols === currentCols) return;
      currentCols = cols;

      /* remove old column wrappers (cards stay referenced in `cards`) */
      grid.querySelectorAll('.reviews-col').forEach(function (c) { c.remove(); });

      var colEls = [];
      for (var i = 0; i < cols; i++) {
        var col = document.createElement('div');
        col.className = 'reviews-col';
        grid.appendChild(col);
        colEls.push(col);
      }

      /* round-robin by index => top row reads 1 2 3 4 5, next 6 7 8 9 10 */
      for (var k = 0; k < cards.length; k++) {
        colEls[k % cols].appendChild(cards[k]);
      }
    }

    layout();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    });
  });

  /* ---------- Show more / progressive reveal ---------- */
  document.querySelectorAll('[data-reviews-grid]').forEach(function (grid) {
    var increment = parseInt(grid.getAttribute('data-increment'), 10) || 8;
    var section = grid.closest('.reviews-section');
    var button = section ? section.querySelector('[data-reviews-show-more]') : null;
    if (!button) return;

    button.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(grid.querySelectorAll('.review-card.is-hidden'));
      if (!hidden.length) return;

      /* reveal in original index order, not column DOM order */
      hidden.sort(function (a, b) {
        return (parseInt(a.getAttribute('data-review-index'), 10) || 0) -
               (parseInt(b.getAttribute('data-review-index'), 10) || 0);
      });

      for (var i = 0; i < hidden.length && i < increment; i++) {
        hidden[i].classList.remove('is-hidden');
      }

      var stillHidden = grid.querySelectorAll('.review-card.is-hidden');
      if (!stillHidden.length) {
        button.setAttribute('hidden', 'hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Write a review modal ---------- */
  var overlay = document.querySelector('[data-reviews-modal-overlay]');
  if (overlay) {
    var openButtons = document.querySelectorAll('[data-reviews-open-modal]');
    var closeButton = overlay.querySelector('[data-reviews-close-modal]');
    var modal = overlay.querySelector('.reviews-modal');

    function openModal() {
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var firstField = overlay.querySelector('input, textarea');
      if (firstField) firstField.focus();
    }

    function closeModal() {
      overlay.setAttribute('hidden', 'hidden');
      document.body.style.overflow = '';
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });

    // Auto-open modal after a successful submission so the thank-you
    // message (rendered server-side via form.posted_successfully?) is visible.
    if (overlay.querySelector('.reviews-modal-success')) {
      openModal();
    }
  }

  /* ---------- Review form: fold rating + optional photo link into the message body ---------- */
  var reviewForm = document.getElementById('ReviewForm');
  if (reviewForm) {
    reviewForm.addEventListener('submit', function () {
      var ratingInput = reviewForm.querySelector('input[name="rating"]:checked');
      var ratingValue = ratingInput ? ratingInput.value : 'Not selected';
      var photoField = document.getElementById('review-photo-link');
      var photoValue = photoField && photoField.value ? photoField.value.trim() : '';
      var bodyField = reviewForm.querySelector('textarea[name="contact[body]"]');

      if (bodyField) {
        var prefix = 'Rating: ' + ratingValue + '/5\n';
        if (photoValue) prefix += 'Photo link: ' + photoValue + '\n';
        prefix += '\nReview:\n';
        bodyField.value = prefix + bodyField.value;
      }
    });
  }
})();
